/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_AutopilotsInputs */

const en_mk_shot_autopilots = /** @type {(inputs: Mk_Shot_AutopilotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Routines page: scheduled work with the agent responsible and the next run time.`)
};

const id_mk_shot_autopilots = /** @type {(inputs: Mk_Shot_AutopilotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Rutinitas: pekerjaan terjadwal beserta agen penanggung jawab dan waktu jalan berikutnya.`)
};

/**
* | output |
* | --- |
* | "The Routines page: scheduled work with the agent responsible and the next run time." |
*
* @param {Mk_Shot_AutopilotsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_autopilots = /** @type {((inputs?: Mk_Shot_AutopilotsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_AutopilotsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_autopilots(inputs)
	return en_mk_shot_autopilots(inputs)
});